import React from 'react'
import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
Swiper.use([Navigation, Pagination])

import { getUrl } from '@js/common/getUrlByDomain'

import { useTrackOnClick } from '@f/hooks/tracking/useTrackOnClick'

import { HouseCard } from './HouseCard'

const SearchResultsHouse = ({ item, showFloorPlansOnly, ...props }) => {
  const images = [
    ...(item.exterior_images?.map((image, index) => {
      image.label = 'Außenansicht'
      image.index = index + 1
      return image
    }) || []),
    ...(item.interior_images?.map((image, index) => {
      image.label = 'Innenansicht'
      image.index = index + 1
      return image
    }) || []),
    ...(item.floor_plans?.map((image, index) => {
      image.label = 'Grundriss'
      image.index = index + 1
      return image
    }) || [])
  ]

  const moveFloorPlansImagesToTheFront = () => {
    const floorPlans = images.filter(img => img.label === 'Grundriss')
    const otherImages = images.filter(img => img.label !== 'Grundriss')

    return [...floorPlans, ...otherImages]
  }

  const getImagesToRender = () => {
    if (showFloorPlansOnly) {
      return moveFloorPlansImagesToTheFront()
    }

    return images
  }

  const imagesToRender = getImagesToRender()

  const handleItemClick = async (event, houseNid) => {
    const { target } = event
    if (
      /SliderArrow|SearchResultsTile-sales-agent-info/.test(target.className)
    ) {
      return
    }

    let label = 'card-houselist-standard'

    if (item.isTopPlacement) {
      label = 'card-houselist-top'
    } else if (item.isLocal) {
      label = 'card-houselist-regio'
    } else if (item.isBranded) {
      label = 'card-houselist-blickfaenger'
    }

    const wtData = {
      category: 'item',
      action: 'click',
      label,
      location: 'search-results',
      values: [{ type: 'house_nid', value: item.nid }]
    }

    useTrackOnClick({ event, wtData })
    if (props.onClick) {
      props.onClick(houseNid)
    }
  }

  const redirectUrl =
    props.variant !== 'ua_embedded'
      ? item.url
      : `${getUrl('userAccount')()}empfohlene-anbieter/${
          props.forcedVendorNid ? props.forcedVendorNid : item.vendor
        }/${item.nid}`

  return (
    <HouseCard
      images={images}
      imagesToRender={imagesToRender}
      item={item}
      redirectUrl={redirectUrl}
      handleItemClick={handleItemClick}
      openSetLocationModal={props.openSetLocationModal}
      disableBranding={props.disableTopPlacementAndBranding}
      variant={props.variant}
    />
  )
}

export default SearchResultsHouse
